export function Footer() {
  return (
    <div className="z-20 w-full bg-background/95 shadow backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-4 flex h-14 items-center">
        <small className="text-xs leading-loose text-muted-foreground text-left">
          StudyPro Teacher v1.0.3
        </small>
      </div>
    </div>
  );
}
